import React from "react";
import AdminUser from "../../adminUser/AdminUser";
import InstitutionScopeEmpty from "../components/InstitutionScopeEmpty";
import { useMasterAdmin } from "../MasterAdminContext";

const MasterAdminAdministrators = () => {
  const { selectedInstitutionId, institutions, loading } = useMasterAdmin();

  if (!loading && institutions.length === 0) {
    return (
      <InstitutionScopeEmpty
        title="No institutions yet"
        description="Create an institution workspace first, then return here to manage its administrators."
      />
    );
  }

  if (!selectedInstitutionId) {
    return (
      <InstitutionScopeEmpty
        title="Loading institutions..."
        description="Please wait while institution workspaces are loaded."
      />
    );
  }

  return (
    <AdminUser
      institutionIdOverride={selectedInstitutionId}
      masterAdminMode
    />
  );
};

export default MasterAdminAdministrators;
